import { useState, FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');
    setMessage('');

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('company_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setMessage('Dziękujemy za zapisanie się do newslettera!');
      setEmail('');
      return;
    }

    formData.delete('company_alt');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9flso6lb8e5uktkmueg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('Dziękujemy za zapisanie się do newslettera! Sprawdź swoją skrzynkę odbiorczą.');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '';
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setStatus('error');
          setMessage('Wystąpił błąd podczas wysyłania. Spróbuj ponownie później.');
        } else {
          setStatus('error');
          setMessage(serverMsg || 'Wystąpił błąd podczas wysyłania. Spróbuj ponownie później.');
        }
      }
    } catch {
      setStatus('error');
      setMessage('Wystąpił błąd sieci. Sprawdź połączenie i spróbuj ponownie.');
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-2xl p-8 md:p-12 border border-background-200">
          <div className="text-center mb-8">
            <div className="w-14 h-14 flex items-center justify-center bg-primary-100 rounded-full mx-auto mb-5">
              <i className="ri-mail-send-line text-xl text-primary-500"></i>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              Najnowsze Kakobuy Spreadsheet Findy
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
              Zapisz się do newslettera i otrzymuj najświeższe znaleziska, porady zakupowe oraz aktualizacje Kakobuy Spreadsheet prosto na swoją skrzynkę.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-readdy-form="">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Twój adres e-mail"
              required
              className="flex-1 px-4 py-3 bg-background-100 border border-background-200 rounded-full text-sm text-foreground-700 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-6 py-3 bg-primary-500 hover:bg-primary-600 disabled:bg-primary-300 text-background-50 font-semibold rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              {status === 'loading' ? (
                <span className="flex items-center gap-2">
                  <i className="ri-loader-4-line animate-spin w-4 h-4 flex items-center justify-center"></i>
                  Wysyłanie...
                </span>
              ) : (
                'Zapisz się'
              )}
            </button>
            <div className="honeypot-field">
              <input type="text" name="company_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>
          </form>

          {status === 'success' && (
            <p className="mt-4 text-sm text-accent-600 text-center font-medium">{message}</p>
          )}
          {status === 'error' && (
            <p className="mt-4 text-sm text-red-500 text-center">{message}</p>
          )}

          <p className="mt-4 text-xs text-foreground-400 text-center">
            Zero spamu. Możesz wypisać się w każdej chwili.
          </p>
        </div>
      </div>
    </section>
  );
}